import 'react-datepicker/dist/react-datepicker.css';

import { DEFAULT_DISPLAY_DATE_FORMAT } from 'core/constants';
import { DatePickerWrapper } from 'core/elements';

import { IProps } from './DateInput';
import { DatePickerStyled } from './style';

const DateInputView = ({
  minDate,
  maxDate,
  dateFormat = DEFAULT_DISPLAY_DATE_FORMAT,
  isClearable = true,
  disabled = false,
}: IProps) => {
  return (
    <DatePickerWrapper isDisabled={disabled}>
      <DatePickerStyled
        {...{
          dateFormat,
          minDate,
          maxDate,
          isClearable,
        }}
      />
    </DatePickerWrapper>
  );
};

export default DateInputView;
